/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import ampInstance from '@omc/apm-upload';
import { Cookies } from 'react-cookie';

import { channelGetLocationInfo, isDouyinAppChannel } from '@/channels';
import { useEffect } from 'react';
import { parseObj } from './index';

const getLocationData = async () => {
  const info = await channelGetLocationInfo();

  return {
    mLat: info.latitude,
    mLon: info.longitude,
    mCityName: '',
  };
};

function getOSInfo() {
  const ua = navigator.userAgent;
  const result = {
    isIOS: false,
    systemType: '',
    systemVersion: '',
    deviceModel: '',
  };

  result.isIOS = /iPhone|iPad|iPod/i.test(ua) && !(window as any).MSStream;

  if (result.isIOS) {
    if (ua.includes('iPhone')) {
      result.systemType = 'iPhone OS';
      result.deviceModel = 'iPhone';
    } else if (ua.includes('iPad')) {
      result.systemType = 'iPad OS';
      result.deviceModel = 'iPad';
    } else if (ua.includes('iPod')) {
      result.systemType = 'iPod OS';
      result.deviceModel = 'iPod';
    }

    const matches = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (matches) {
      result.systemVersion = matches[1] + '.' + matches[2] + (matches[3] ? '.' + matches[3] : '');
    }

    const modelMatches = ua.match(/; ([^;]+) AppleWebKit/);
    if (modelMatches && modelMatches[1]) {
      result.deviceModel = modelMatches[1];
    }
  }

  return result;
}

const MCDNetworkStatusMap: Record<string, number> = {
  WIFI: 1,
  G2: 2,
  G3: 3,
  G4: 4,
  G5: 5,
  NONE: 0,
};

export const getNetWorkType = () => {
  const ua = navigator.userAgent;
  let networkStr = ua.match(/NetType\/\w+/)?.[0] || 'NetType/other';
  networkStr = networkStr.toLowerCase().replace('nettype/', '');
  let networkType: string;
  switch (networkStr) {
    case 'wifi':
      networkType = 'WIFI';
      break;
    case '4g':
      networkType = 'G4';
      break;
    case '3g':
      networkType = 'G3';
      break;
    case '3gnet':
      networkType = 'G3';
      break;
    case '2g':
      networkType = 'G2';
      break;
    default:
      networkType = 'NONE';
  }
  return MCDNetworkStatusMap[networkType];
};

const ampHandlerInit = () => {
  const modelInfo = getOSInfo();
  const cookies = new Cookies();

  ampInstance.init({
    staticProps: {
      mChannel: isDouyinAppChannel() ? 'douyin' : 'UnionPay',
      mClientType: modelInfo.isIOS ? 101 : 102,
      mDeviceManu: modelInfo.deviceModel,
      mSysVersion: `${modelInfo.systemType} ${modelInfo.systemVersion}`,
      mAppVersion: '6.0.35.0',
    },
    dynamicProps: {
      sid: () => cookies.get<string>('wsid') || cookies.get<string>('sid') || '',
      tid: () => cookies.get<string>('tid') || '',
      meddyId: () => cookies.get<string>('meddyId') || '',
      ct: () => (isDouyinAppChannel() ? '38' : '37'),
      locationData: getLocationData,
      netWorkType: getNetWorkType,
    },
    requestSaveLimit: 0,
  });
};

const getRequestData = (requestConfig: any) => {
  const _isAbsoluteUrl = new RegExp(/^(https?:)?\/\//).exec(requestConfig.url as string) !== null;
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const _url = _isAbsoluteUrl ? requestConfig.url : `${requestConfig.baseURL || ''}${requestConfig.url}`;

  const _toObj = (val: unknown): any => {
    if (typeof val === 'string') {
      return parseObj(val);
    }
    return val;
  };

  return {
    method: requestConfig.method,
    header: requestConfig.headers,
    timestamp: Number(requestConfig.headers?.['request-timestamp']) || Date.now(),
    traceid: requestConfig.headers?.['x-b3-traceid'],
    href: window.location.href,
    url: _url,
    data: {
      ...(_toObj(requestConfig.data) || {}),
      ...(_toObj(requestConfig.params) || {}),
    },
  };
};

const getReponseData = (response: any) => {
  return {
    status: response?.status,
    data: response?.data,
    timestamp: Date.now(),
  };
};

const getErrorData = (error: any) => {
  return {
    status: error?.response?.status,
    data: {
      ...error?.response?.data,
      message: error?.message,
    },
    timestamp: Date.now(),
  };
};

const isProd = process.env.APP_DEPLOY_ENV === 'prod';

const ampHandler = isProd
  ? ampInstance
  : {
      // eslint-disable-next-line @typescript-eslint/no-implied-eval, no-new-func
      uploadPerformanceInfo: new Function(),
    };

export const useAmpHandler = () => {
  useEffect(() => {
    try {
      if (isProd) {
        ampHandlerInit();
      }
    } catch (error) {
      console.error('ampHandlerInit error', error);
    }
  }, []);
};

export const ampHandlerHelpers = {
  getRequestData,
  getReponseData,
  getErrorData,
};

export { ampHandlerInit, ampHandler };
